import { Component } from 'react';
import SwapBox from 'common/components/SwapBox/SwapBox';
import lodash from 'lodash';
import styles from './UsersSelector.scss';
class UsersSelector extends Component {

    handleAddUser(id) {
        const { input, users } = this.props;
        const userToAdd = this.getFormattedUsers(users).filter(user => user.id === id);
        const selectedUsers = input.value || [];
        input.onChange(selectedUsers.concat(userToAdd));
    }

    handleAddAllInternalUsers() {
        const { input, internalUsers } = this.props;
        const selectedUsers = input.value || [];
        const formattedUsers = this.getFormattedUsers(internalUsers);
        input.onChange(lodash.uniqBy(selectedUsers.concat(formattedUsers), 'id'));
    }

    handleRemoveUser(id) {
        const { input } = this.props;

        const selectedUsers = input.value.filter(user => user.id !== id);
        input.onChange(selectedUsers);
    }

    handleSearch(evt) {
        const { reloadUsers, binderId } = this.props;
        const query = lodash.get(evt, 'target.value', '');
        lodash.throttle(reloadUsers, 100)(lodash.trim(query), binderId);
    }

    getFormattedUsers(users) {
        return lodash.map(users, user =>
            ({ ...user, details: [user.emailAddress] })
        );
    }

    render() {
        const {
            input,
            users,
        } = this.props;
        const availableUsers = lodash.differenceWith(this.getFormattedUsers(users), input.value, lodash.isEqual);
        return (
            <div data-cy="UsersSelector">
                <h3 className={styles.recipientsTitle}>Recipients</h3>
                <AddAllUsersButton
                    text='Select Study Team'
                    input={input}
                    addAllUsers={this.handleAddAllInternalUsers.bind(this)}
                    data-cy="UsersSelector-AddAllUsersButton"/>
                <SwapBox
                    title='Users'
                    selected={input.value || []}
                    available={availableUsers}
                    addSelected={this.handleAddUser.bind(this)}
                    removeSelected={this.handleRemoveUser.bind(this)}
                    searchHandler={this.handleSearch.bind(this)}>
                </SwapBox>
            </div>
        );
    }
}


const AddAllUsersButton = ({ text, addAllUsers }) => {
    return (
        <button className={styles.addAllUsersButton} type="button" onClick={addAllUsers}>{text}</button>
    );
};

export default UsersSelector;
